import React from 'react';
import GalleryItem from './GalleryItem';

function Gallery({ items, type, idCasa, loading, onDeleteComplete, entityCode }) {
    if (loading) {
        return (
            <div className='text-center py-5'>
                <div className='spinner-border text-primary' role='status'>
                    <span className='sr-only'>Cargando...</span>
                </div>
                <p className='mt-2 text-muted'>Cargando {type === 'images' ? 'imágenes' : 'videos'}...</p>
            </div>
        );
    }

    if (!items || items.length === 0) {
        return (
            <div className='text-center py-5'>
                <i className={`fas ${type === 'images' ? 'fa-image' : 'fa-video'} fa-3x text-muted mb-3`}></i>
                <p className='text-muted'>
                    No hay {type === 'images' ? 'imágenes cargadas' : 'videos cargados'}
                </p>
            </div>
        );
    }

    return (
        <div className='row g-3'>
            {items?.map(item => (
                <div key={item.app_simple_storage_object_id} className='col-12 col-sm-6 col-md-4 col-lg-3'>
                    <GalleryItem
                        item={item}
                        type={type}
                        idCasa={idCasa}
                        onDeleteComplete={onDeleteComplete}
                        entityCode={entityCode}
                    />
                </div>
            ))}
        </div>
    );
}

export default Gallery;
